import React from 'react';

const Blogs = () => {
    return (
        <div className='text-white'>
            <h1 className='text-5xl text-center font-bold mb-5'>My <span>Blogs</span></h1>
            <p className='text-2xl text-center'>Coming soon</p>
        </div>
    );
};

export default Blogs;